import { createId } from '@paralleldrive/cuid2'
import { buttonVariants } from 'app/_components/Button'
import Link from 'next/link'
import { toast } from 'react-hot-toast/headless'

type NotificationProps = {
  title?: string
  body?: string
  note?: string
  id?: string
  link?: { href: string; label: string }
  duration?: number
}

const Content = ({ title, body, note, id, link }: NotificationProps) => (
  <>
    {title && <p className="text-sm font-medium">{title}</p>}
    {body && <p className="text-sm">{body}</p>}
    {link && (
      <Link
        href={link.href}
        onClick={() => toast.remove(id)}
        className={buttonVariants({
          variant: 'outline',
          className: 'mt-2 h-auto bg-transparent py-2',
        })}
      >
        {link.label}
      </Link>
    )}
    {note && <p className="text-secondary text-xs">{note}</p>}
  </>
)

const defaultTitles = {
  success: 'Erfolg',
  error: 'Fehler',
  info: 'Info',
  warning: 'Achtung',
} as const

export const notification = {
  success: ({
    title = defaultTitles.success,
    body,
    note,
    id = createId(),
    link,
    duration = 3000,
  }: NotificationProps) =>
    toast.custom(
      <Content title={title} body={body} note={note} id={id} link={link} />,
      // @ts-ignore type is not allowed to hand over but should be. See https://github.com/timolins/react-hot-toast/issues/306
      { type: 'success', duration, id },
    ),
  error: ({ title = defaultTitles.error, body, note, id }: NotificationProps) =>
    toast.custom(
      <Content title={title} body={body} note={note} />,
      // @ts-ignore type is not allowed to hand over but should be. See https://github.com/timolins/react-hot-toast/issues/306
      { type: 'error', duration: 5000, id },
    ),
  info: ({ title = defaultTitles.info, body, note, id }: NotificationProps) =>
    toast.custom(
      <Content title={title} body={body} note={note} />,
      // @ts-ignore type is not allowed to hand over but should be. See https://github.com/timolins/react-hot-toast/issues/306
      { type: 'info', duration: 3000, id },
    ),
  warning: ({
    title = defaultTitles.warning,
    body,
    note,
    id,
  }: NotificationProps) =>
    toast.custom(
      <Content title={title} body={body} note={note} />,
      // @ts-ignore type is not allowed to hand over but should be. See https://github.com/timolins/react-hot-toast/issues/306
      { type: 'warning', duration: 5000, id },
    ),
}
